import {StoryTool} from "../StoryTool";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFilePen, faHammer, faNetworkWired, faNoteSticky, faScroll} from "@fortawesome/free-solid-svg-icons";
import React from "react";
import {ScriptContent} from "./ScriptContent";

export class Script implements StoryTool {
    id = 'script'
    name = "Script"
    paths = [
        `/projects/:projectId/stories/:storyId/${this.id}`,
    ]
    enabled = false
    icon = <FontAwesomeIcon icon={faScroll}/>
    entryPoint = <ScriptContent/>
    link = (projectId?: string, storyId?: string) => `/projects/${projectId}/stories/${storyId}/${this.id}`
}